/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';

/**
 * 
 * @export
 * @interface GetLegalProtectionRiskResponse
 */
export interface GetLegalProtectionRiskResponse {
    /**
     * 
     * @type {string}
     * @memberof GetLegalProtectionRiskResponse
     */
    type: string;
    /**
     * 
     * @type {PersonDto}
     * @memberof GetLegalProtectionRiskResponse
     */
    person?: PersonDto;
}

/**
 * Check if a given object implements the GetLegalProtectionRiskResponse interface.
 */
export function instanceOfGetLegalProtectionRiskResponse(value: object): value is GetLegalProtectionRiskResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetLegalProtectionRiskResponseFromJSON(json: any): GetLegalProtectionRiskResponse {
    return GetLegalProtectionRiskResponseFromJSONTyped(json, false);
}

export function GetLegalProtectionRiskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLegalProtectionRiskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'person': json['person'] == null ? undefined : PersonDtoFromJSON(json['person']),
    };
}

export function GetLegalProtectionRiskResponseToJSON(json: any): GetLegalProtectionRiskResponse {
    return GetLegalProtectionRiskResponseToJSONTyped(json, false);
}

export function GetLegalProtectionRiskResponseToJSONTyped(value?: GetLegalProtectionRiskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'person': PersonDtoToJSON(value['person']),
    };
}

